export default __webpack_public_path__ + "static/media/trade.0c2bf31a.svg";